module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Publié par")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Dreamspinner Press")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("5032 Capital Circle SW"), _c('br'), _vm._v("Ste 2, PMB# 279"), _c('br'), _vm._v("Tallahassee, FL 32305-7886 ")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("USA")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Ceci est une œuvre fictive. Les noms, les personnages, les lieux et les faits décrits ne sont que le produit de l’imagination de l’auteur, ou utilisés de façon fictive. Toute ressemblance avec des personnes ayant réellement existé, vivantes ou décédées, des établissements commerciaux, des événements ou des lieux ne serait que le fruit d’une coïncidence.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Titre original : Cover Up")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Copyright © 2012 KC Burn")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Traduit de l’anglais par Ingrid Lecouvez")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Illustration de la couverture : L.C. Chase - http://www.lcchase.com")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Tous droits réservés. Aucune partie de cet e-book ne peut être reproduite ou transférée d’aucune façon que ce soit ni par aucun moyen, électronique ou physique sans la permission écrite de l’éditeur, sauf dans les endroits où la loi le permet. Cela inclut le photocopiage, les enregistrements et tout système de stockage et de retrait d’information. Pour demander une autorisation, et pour toute autre demande d’information, merci de contacter Dreamspinner Press, 5032 Capital Cir. ")]), _c('span', {
    staticClass: "t3"
  }, [_vm._v("SW, Ste 2 PMB# 279, Tallahassee, FL 32305-7886, USA")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("http://www.dreamspinnerpress.com/")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Édité aux États-Unis d’Amérique.")])]), _vm._v(" "), _c('p', {
    staticClass: "p1"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Première édition")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Décembre 2012")])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t3"
  }, [_vm._v("Édition e-book en français : 978-1-62798-985-5")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad4a8b1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/003.vue
// module id = 60
// module chunks = 0